import React from 'react';
import { useTranslation } from 'react-i18next';
import MaterialIcon from 'commons/src/components/MaterialIcon';

type Props = {
    errorHeader?: string;
    errorText?: string;
    errorIcon?: string;
};

const Error = (props: Props) => {
    const { errorHeader, errorText, errorIcon } = props;
    const { t: txt } = useTranslation();
    return (
        <div className="error-page">
            <div className="error-page__header">
                <div className="error-page__title">
                    {errorHeader ? txt(errorHeader) : txt('PublicIAQDashboard.UhOh')}
                </div>
            </div>
            <div className="error-page__wrapper">
                <MaterialIcon extraClass="error-page__icon" name={errorIcon || 'help_outline'} />
                <div className="error-page__subtitle">
                    {errorText ? txt(errorText) : txt('PublicIAQDashboard.TryAgain')}
                </div>
            </div>
        </div>
    );
};

Error.defaultProps = {
    errorHeader: undefined,
    errorText: undefined,
    errorIcon: undefined,
};

export default Error;
